import React, { useState, useEffect } from "react";
import { CustomersFileType } from "../Common/Types/types";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { CustomersApi } from "./api";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../Core/store.hooks";
import {
  getCustomerListSelector,
  loadingCustomerListSelector,
} from "../Search/Slice";
import { useSelector } from "react-redux";

interface MachinesListWidgetProps {
  id: string;
  header: string;
}
interface MachinesListItemProps {
  key: string;
  machine: any;
  expand: boolean;
  selectMachine: any;
  selectedMachine: string;
}
const MachineDetail = (props: MachinesListItemProps) => {
  const renderLock = (dataItem: any) => {
    if (dataItem.phoneTypes == null) return "";
    if (dataItem.phoneTypes.indexOf(5) > -1) {
      return (
        <SvgIcon
          style={{
            color: "#474747",
            fontSize: "20px",
            marginLeft: "5px",
            verticalAlign: "top",
            top: "2px",
          }}
          icon={svgIcons.lockIcon}
          size="medium"
        />
      );
    } else if (dataItem.phoneTypes.indexOf(6) > -1) {
      return (
        <img
          style={{ marginLeft: "5px" }}
          src="../../assets/img/gateway.png"
          onClick={() =>
            window.open("https://gatemanager.powerplatform.net/lm", "_self")
          }
        />
      );
    }
    return "";
  };

    let fontWeight = "normal";
    let color = "rgb(0, 88, 233)";
    if (props.machine.machineSn == props.selectedMachine) {
        fontWeight = "bold";
        color = "#000";
    }
  if (props.expand && props.machine.deviceList != null) {
    return (
        <div
        onClick={() => props.selectMachine(props.machine)}
        style={{
          display: "inline-block",
          margin: "12px 20px",
          verticalAlign: "top",
          cursor: "pointer",
        }}
      >
        <div
          style={{ fontWeight: fontWeight,color:color }}
          onClick={() => props.selectMachine(props.machine.machineSn)}
        >
          {(props.machine.assemblyName != null
            ? props.machine.assemblyName
            : " ") +
            " " +
            props.machine.machineSn}{" "}
          {renderLock(props.machine)}
        </div>
        <div style={{ marginLeft: "15px" }}>
          {props.machine.deviceList.map((d) => {
            if (
              d.deviceFeature == "Auto bending" ||
              d.deviceFeature == "Storage" ||
              d.deviceFeature == "Stacker" ||
              d.deviceFeature == "Portal robot" ||
              d.deviceFeature == "FastLoadingDevice" ||
              d.deviceFeature == "Unloading_OwnControl" ||
              d.deviceFeature == "Loading_OwnControl" ||
              d.deviceFeature == "Stacking_OwnControl"
            ) {
              return (
                <span style={{ fontSize: "10px", display: "block" }}>
                  {" "}
                  {d.deviceName +
                    " " +
                    (d.serialNumber != null ? d.serialNumber : "")}{" "}
                </span>
              );
            }
          })}
        </div>
      </div>
    );
  }
  return (
    <div
      onClick={() => props.selectMachine(props.machine)}
      style={{
        display: "inline-block",
        margin: "12px 20px",
        cursor: "pointer",
          fontWeight: fontWeight,
        color:color
      }}
    >
      {(props.machine.assemblyName != null ? props.machine.assemblyName : " ") +
        " " +
        props.machine.machineSn}
      {renderLock(props.machine)}
    </div>
  );
};
const MachineListWidget = (props: MachinesListWidgetProps) => {
  const globalParams = useSelector(getParamsSelector);

  const [machines, updateMachines] = useState(null);
  const [machinesLoading, updateMachinesLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>(null);
  const [expand, updateExpand] = useState(true);
  const [selectedMachine, updateSelectedMachine] = useState(null);

  const customerList: any = useSelector(getCustomerListSelector);
  const dispatch = useAppDispatch();
  const { queryparams } = useParams();

  useEffect(() => {
    if (globalParams.customerID != null) GetMachineList();
  }, [globalParams.customerID]);
  useEffect(() => {
    updateSelectedMachine(globalParams.mainMachineSerialNo);
  }, [globalParams.mainMachineSerialNo]);

  const GetMachineListFromCustomerCache = () => {
    if (customerList != null) {
      for (var i = 0; i < customerList.length; i++) {
        if (customerList[i].customerID == globalParams.customerID) {
          return customerList[i].machines;
        }
      }
    }
    return null;
  };
  const GetMachineList = () => {
    let cacheMachines = GetMachineListFromCustomerCache();
    if (cacheMachines == null) {
      updateMachinesLoading(true);
      setErrorMessage(null);
      CustomersApi.getMachineList({ customerId: globalParams.customerID })
        .then((response: any) => {
          updateMachines(response);
          updateMachinesLoading(false);
          setErrorMessage(null);
        })
        .catch((error) => {
          if (error.message != "canceled") {
            updateMachinesLoading(false);
            setErrorMessage("Oops something went wrong, unable to get data.");
          }
        });
    } else {
      updateMachines(cacheMachines);
    }
  };
  const selectMachine = (mach: any) => {
      const params: any = Object.assign({}, globalParams);
      params.customerID = globalParams.customerID;
    params.mainMachineSerialNo = mach.machineSn;
      params.machine = mach;
     // console.log(params)
    dispatch<any>(updateParams(params));
  };
  const renderZoomIcon = () => {
    if (expand) {
      return (
        <SvgIcon
          style={{
            color: "#474747",
            fontSize: "20px",
            marginLeft: "5px",
            verticalAlign: "top",
            top: "40px",
            position: "absolute",
            right: "10px",
            cursor: "pointer",
          }}
          icon={svgIcons.zoomOutIcon}
          size="medium"
          onClick={() => updateExpand(false)}
        />
      );
    } else {
      return (
        <SvgIcon
          style={{
            color: "#474747",
            fontSize: "20px",
            marginLeft: "5px",
            verticalAlign: "top",
            top: "40px",
            position: "absolute",
            right: "10px",
            cursor: "pointer",
          }}
          icon={svgIcons.zoomInIcon}
          size="medium"
          onClick={() => updateExpand(true)}
        />
      );
    }
  };

  if (machinesLoading == true) {
    return <Spinner text="data" />;
  }
  if (machinesLoading === false && machines === null) {
    return (
      <>
        <br />
        <ErrorMessage text={errorMessage} id={props.id} header={props.header} />
      </>
    );
  }
  return (
    <div>
      {renderZoomIcon()}
      <h6>Machines listed in MPE database</h6>
      {machines.map((m) => {
        if (m.dataSource == "MPE") {
          return (
            <MachineDetail
              key={m.machineSn}
              machine={m}
              expand={expand}
              selectMachine={selectMachine}
              selectedMachine={selectedMachine}
            />
          );
        }
      })}
      <hr />
      <h6>Machines listed only in D365 database</h6>
      {machines.map((m) => {
        if (m.dataSource == "D365") {
          return (
            <MachineDetail
              key={m.machineSn}
              machine={m}
              expand={expand}
              selectMachine={selectMachine}
              selectedMachine={selectedMachine}
            />
          );
        }
      })}
    </div>
  );
};
export default MachineListWidget;
